import { format } from 'date-fns'

export default {
  filters: {
    age(birthday) {
      const today = new Date()
      const birthDate = new Date(birthday)
      let age = today.getFullYear() - birthDate.getFullYear()
      const m = today.getMonth() - birthDate.getMonth()
      if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--
      }
      return age
    },
    formatDateTime(value) {
      if (value) {
        return format(new Date(value), 'dd MMM yyyy HH:mm')
      }
      return ''
    },
    formatDayNameDateTime(value) {
      if (value) {
        return format(new Date(value), 'iii,  dd MMM yyyy HH:mm')
      }
      return ''
    },
    formatDate(value) {
      if (value) {
        return format(new Date(value), 'dd MMM yyyy')
      }
      return ''
    },
    titleCase(value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    capitalize(value) {
      if (!value) return ''
      value = value.split(' ')

      for (var i = 0, x = value.length; i < x; i++) {
        value[i] = value[i][0].toUpperCase() + value[i].substr(1)
      }

      return value.join(' ')
    }
  }
}
